import { Button, CircularProgress } from "@mui/material";
import React from "react";

const defaultProps = {
  disabled: false,
  startIcon: null,
  loading: false,
  onClick: () => {},
  label: "",
  variant: "contained",
};

const LoadingButton = (props = defaultProps) => {
  const { loading, label } = props;
  return (
    <Button {...defaultProps} {...props}>
      {loading ? <CircularProgress size={24} color="inherit" /> : label}
    </Button>
  );
};

export default LoadingButton;
